export const createUserPromptsService = ({
  supabase,
  tableName,
  sessionUserId,
  isMissingRelationError,
  onMissingRelationError,
  createId,
}) => {
  const mapUserPromptRow = (row) => ({
    id: String(row?.prompt_id || row?.id || createId()),
    name: String(row?.name || ""),
    mod: String(row?.mod || "CT"),
    befund: String(row?.befund || ""),
    beurteilung: row?.beurteilung || null,
    created_at: row?.created_at || Date.now(),
  });

  const loadVorlagen = async () => {
    if (!sessionUserId || !supabase) return { supported: false, vorlagen: [] };

    try {
      const { data, error } = await supabase
        .from(tableName)
        .select("prompt_id,name,mod,befund,beurteilung,created_at")
        .eq("user_id", sessionUserId)
        .order("created_at", { ascending: true });

      if (error) {
        if (isMissingRelationError(error)) {
          onMissingRelationError?.();
          return { supported: false, vorlagen: [] };
        }
        throw error;
      }

      return {
        supported: true,
        vorlagen: Array.isArray(data) ? data.map(mapUserPromptRow) : [],
      };
    } catch (error) {
      console.error("Fehler beim Laden der user_prompts:", error);
      if (isMissingRelationError(error)) {
        onMissingRelationError?.();
        return { supported: false, vorlagen: [] };
      }
      return { supported: true, vorlagen: [], error };
    }
  };

  const upsertVorlage = async (prompt) => {
    if (!sessionUserId || !supabase) return { ok: false, supported: false };

    const payload = {
      user_id: sessionUserId,
      prompt_id: String(prompt.id || createId()),
      name: String(prompt.name || "").trim(),
      mod: String(prompt.mod || "CT"),
      befund: String(prompt.befund || ""),
      beurteilung: prompt.beurteilung || null,
      created_at: prompt.created_at || Date.now(),
      updated_at: new Date().toISOString(),
    };

    try {
      const { error } = await supabase
        .from(tableName)
        .upsert(payload, { onConflict: "user_id,prompt_id" });

      if (error) {
        if (isMissingRelationError(error)) {
          onMissingRelationError?.();
          return { ok: false, supported: false };
        }
        throw error;
      }

      return { ok: true, supported: true };
    } catch (error) {
      console.error("Fehler beim Speichern in user_prompts:", error);
      if (isMissingRelationError(error)) {
        onMissingRelationError?.();
        return { ok: false, supported: false, error };
      }
      return { ok: false, supported: true, error };
    }
  };

  const deleteVorlage = async (promptId) => {
    if (!sessionUserId || !supabase) return { ok: false, supported: false };

    try {
      const { error } = await supabase
        .from(tableName)
        .delete()
        .eq("user_id", sessionUserId)
        .eq("prompt_id", String(promptId || ""));

      if (error) {
        if (isMissingRelationError(error)) {
          onMissingRelationError?.();
          return { ok: false, supported: false };
        }
        throw error;
      }

      return { ok: true, supported: true };
    } catch (error) {
      console.error("Fehler beim Löschen in user_prompts:", error);
      if (isMissingRelationError(error)) {
        onMissingRelationError?.();
        return { ok: false, supported: false, error };
      }
      return { ok: false, supported: true, error };
    }
  };

  return {
    loadVorlagen,
    upsertVorlage,
    deleteVorlage,
  };
};
